
const Tracker = require('../../../global/js/modules/google-analytics');

function addListener($el, type) {

    if ($el.hasAttribute('href') && $el.href.match(/^tel:/)) {
        $el.addEventListener(type, event => {
            let eventLabel = document.title;
            const defaultTitle = ' - Hertz Rental Trucks Australia';

            if (eventLabel.endsWith(defaultTitle)) {
                eventLabel = eventLabel.substring(0, eventLabel.indexOf(defaultTitle));
            }

            Tracker.track('Telephone Link Click', 'click', eventLabel);
        });
    }

    $el.addEventListener(type, event => {
        Tracker.track('User Interaction', type, Tracker.guessContext(event));
    });
}

document.addEventListener('DOMContentLoaded', () => {

    const obs = [
        ['a', 'click'],
        ['button, input[type=button]', 'click'],
        ['form', 'submit']
    ];

    for (o of obs) {
        const $elements = document.querySelectorAll(o[0]);

        if ($elements.length === 0) {
            continue;
        }

        for ($element of $elements) {
            addListener($element, o[1]);
            continue;
        }

    }

});